import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class GeneralFunctionsService {

  constructor() { }


  public addRelatie() {
    alert("Nog niet geimplementeerd");
  }


  public handleError(toastr:ToastrService,error: any) {
    try {
      toastr.error("", error.originalError.info.message, {timeOut: 0});
    }catch(e) {

    }
  }

  public s2ab(s) {
    var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf);  //create uint8array as viewer
    for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
    return buf;
  }


  public toDate(date : Date) :string {
    let month =  (date.getMonth() + 1).toString();
    if (month.length < 2) month = "0" + month;
    return date.getFullYear() + "-" + month + "-" + date.getDate()  + "T00:00:00.000Z";
  }

  public strToNum(value : number| string) {
      let amount = value ? value.toString() : '0';
      amount = amount.replace(/\s/g, '');
      amount = amount.replace(/,/g, '.');
      return (Number(amount));
  }

}
